import { render, staticRenderFns } from "./ManualPage.vue?vue&type=template&id=35cc2996&"
import script from "./ManualPage.vue?vue&type=script&lang=js&"
export * from "./ManualPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports